import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=dfdc7a18&"
import script from "./popup.vue?vue&type=script&lang=js&"
export * from "./popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfdc7a18')) {
      api.createRecord('dfdc7a18', component.options)
    } else {
      api.reload('dfdc7a18', component.options)
    }
    module.hot.accept("./popup.vue?vue&type=template&id=dfdc7a18&", function () {
      api.rerender('dfdc7a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/popup.vue"
export default component.exports